import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/authContext";
import "./Annoucement.css";
import AnnoucementSlice from "./AnnoucementSlice/AnnoucementSlice";
import SearchBar from "./SearchBar/SearchBar";
import MakeAnAnnouncement from "../Modals/MakeAnAnnouncement/MakeAnAnnouncement";
import { fetchingAll } from "../../Functions/CRUD/Announcement/announcementHelper";
import { useLoading } from '../../context/loadingContext';
import LoadingPage from '../../Error/LoadingPage/LoadingPage'


const Annoucement = () => {
   const { setLoading }= useLoading()
   const { user} = useContext(AuthContext);
  const [Tri, setTri] = useState("");
  const [Search, setSearch] = useState("");
  const [MakeAnnouncement, setMakeAnnouncement] = useState(false);
  const [AnnoucementPosts, setAnnoucementPosts] = useState(null);

  const fetch4announcement = async () => {
 
    const data = await fetchingAll();
    setAnnoucementPosts(data || []);
    console.log(AnnoucementPosts);
   
  };

  useEffect(() => {
    fetch4announcement();
  }, []);
  if (!AnnoucementPosts) {
    return <LoadingPage/>;
  }

  return (
    <div className="Annoucement">
      <div className="Annoucement-header">
        <div className="circle circle-left"></div>
        <div className="circle circle-right"></div>

        <div>
          <h1>Announcements</h1>
          <SearchBar setSearch={setSearch} Search={Search} />
        </div>
      </div>
      <div className="Announcement-body">
        <div className="Buttons">
          <div className="Annoucement-button-section">
            <button
              className={Tri === "" ? "Active" : null}
              onClick={() => setTri("")}
            >
              All
            </button>
            <button
              className={Tri === "News" ? "Active" : null}
              onClick={() => setTri("News")}
            >
              News
            </button>
            <button
              className={Tri === "Article" ? "Active" : null}
              onClick={() => setTri("Article")}
            >
              Articles
            </button>
          </div>
          {user?.role?.toLowerCase() === "admin" ? (
            <button
              onClick={() => setMakeAnnouncement(!MakeAnnouncement)}
              className="MakeAnnouncement"
            >
              Make an announcement
            </button>
          ) : null}
        </div>

        <div className="AnnouncementPosts">
          {AnnoucementPosts.length===0? <p className="error">
            No Annoucements are made yet ...
          </p>
          :(sortAnnouncementsByDate(AnnoucementPosts)
            ?.filter(
              (el) =>
                el.Title.toLowerCase().includes(Search.toLowerCase()) &&
                el.Type.includes(Tri)
            )
            .map((el) => (
              <AnnoucementSlice Post={el} />
            )))}
        </div>
        {MakeAnnouncement ? (
          <MakeAnAnnouncement setMakeAnnouncement={setMakeAnnouncement} />
        ) : null}
      </div>
    </div>
  );
};

export default Annoucement;

function sortAnnouncementsByDate(data) {
  return data?.sort((a, b) => {
    const dateA = new Date(a.Date);
    const dateB = new Date(b.Date);
    return dateB - dateA; // descending (latest first)
  });
}
